export default "__VITE_ASSET__Dr9_OiaD__"